import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class FileService {
  constructor(private http: HttpClient) {}

  fileUpload(element: any, url: string): Observable<any> {
    const formData = new FormData();
    formData.append("file", element, element.name);
    return this.http.post<Observable<any>>(url, formData);
  }

  fileUploadCollection(entity: any, element: any, url: string): Observable<any> {
      const formData = new FormData();
      formData.append("file", element, element.name);
      formData.append("entity", entity);
      return this.http.post<Observable<any>>(url, formData);
  }
}
